import {request} from '../order-request.js'

/**
 * 获取订单系统粉丝的订单列表
 * @param {Object} param 请求参数
 * @param {Object} callback
 */
export function getOrderList(param,callback){
	request({
		method: 'post',
		url: 'im/order/getListWithPage',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}
